import { render } from "./pop-up.vue?vue&type=template&id=5e60d50c&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=5e60d50c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e60d50c"

export default script